import { BrowserRouter } from 'react-router-dom';
import { FC, useEffect, useRef } from 'react';

import Pages from 'pages';
import ThemeProvider from 'theme';
import StoreProvider from 'store/StoreProvider';
import ToasterProvider from 'components/common/Toaster/Toaster';
import { DEFAULT_TITLE } from 'configs';
import useBranding from 'store/branding';

const PreloaderCleanup: FC = () => {
  const [brandingState] = useBranding();
  const { status } = brandingState;
  const removedPreloaderRef = useRef(false);

  useEffect(() => {
    if (removedPreloaderRef.current) return;
    const brandingReady = status !== 'loading' && status !== 'idle';
    if (!brandingReady) return;

    const el = typeof document !== 'undefined' ? document.getElementById('preloader') : null;
    if (el) {
      el.remove();
      removedPreloaderRef.current = true;
    }
  }, [status]);

  return null;
};

const App: FC = () => {
  useEffect(() => {
    document.title = DEFAULT_TITLE;
  }, []);

  return (
    <BrowserRouter>
      <StoreProvider>
        <ThemeProvider>
          <ToasterProvider>
            <PreloaderCleanup />
            <Pages />
          </ToasterProvider>
        </ThemeProvider>
      </StoreProvider>
    </BrowserRouter>
  );
};

export default App;
